import * as React from "react";
import { Block as BaseBlock, BlockProps } from "baseui/block";
import { expandBorder, expandBorderRadius } from "../utils/styles";
import { getContextImage, useImageContext } from "../Image";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export type TExtendedBlockProps = {
  backgroundImage?: TODO;
  backgroundRepeat?: TODO; // Baseweb types unaware of these also
  backgroundPosition?: TODO;
  borderColor?: TODO;
  borderStyle?: TODO;
  borderWidth?: TODO;
  borderRadius?: TODO;
} & BlockProps;

function Block(props: TExtendedBlockProps) {
  // Extract props not intended to be passed further
  const {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    backgroundImage,
    borderColor,
    borderStyle,
    borderWidth,
    borderRadius,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    className = "",
    ...restProps
  } = props;

  const [css, $theme] = useStyletron();
  const borderStyles = getBorderStyles({ $theme, ...props });
  const context = useImageContext();

  return (
    <BaseBlock
      // @ts-ignore Baseweb types aren't aware of this
      backgroundImage={getImageUrl(backgroundImage, context)}
      // NOTE: probably need a better way to extend styles than 'css()'.
      className={`${className} ${css(borderStyles)}`}
      {...restProps}
    />
  );
}

function getImageUrl(src, context) {
  const img = getContextImage(src, context);
  if (img) {
    return `url("${img}")`;
  }
}

const getBorderStyles = ({
  $theme,
  borderColor = "mono400",
  borderStyle = "solid",
  borderWidth = 0,
  borderRadius = 0,
}) => {
  return {
    ...expandBorderRadius($theme.borders[borderRadius] || borderRadius),
    ...expandBorder($theme.colors[borderColor] || borderColor, "Color"),
    ...expandBorder(borderStyle, "Style"),
    ...expandBorder(borderWidth, "Width"),
  };
};

export { Block };
